const activationIds = [
  "ARFKG9NTY8", "VM3A9XCJXF", "ESZJN9SJTD", "39FRQ75R", "NY3ZNDAHUE",
  "R9WZR6GUDR", "SUTQ3MNCK", "P48TFKN9MM", "VRQCJYRBQD", "AY4CHT9BNT",
  "PY8P4WMA7T", "3WAM54KEM6", "CZ7YE8F3WS", "Y2DVDCVD5G", "JFB56TTSYZ",
  "XRSWA28FA4", "XHP5S9ZV6Y", "YCBX58KPXM", "QWWDNQ843",
  "NXQA23YUD4", "J5BAM74CSE", "NZH3VWH88Z", "EBCH2AB9T", "QXBUEDG2MV",
  "AHHZV9S463", "W3U6YPWVM", "S4RU3ERKET", "9KE8ARFJ6M",
  "Z36N5TJ85", "ZN8JE468TD", "9H9KPHKAF3", "KQMEKT7UP", "MTGH8UZ5N",
  "X57BJ22JFF", "GQY448DA5", "URNYWYZRHA", "JSCJD9W2Z", "S2JHMNNQ5",
  "82YQ9AYEMJ", "6NDSDZCHZR", "4JMVJKGMD", "T7UKG57UX",
  "5GAR738HQA", "CYTX5ECDCP", "8PN8ZG3V6D", "4SQ3ZBP7FY", "W8RUTPE3C",
  "WASCWA8Q8D", "GP9QWAG4QG", "7Z5QK838WU", "DXZMY6K66H", "4UNZ5AJPWU",
  "EW3BMV4T3", "GHSCZNPZWM", "ZQ6BAJWC6M", "3JCPU6CTV", "CXRDRKKBD",
  "2REBVSR4MK", "78WYHK2965", "WA4G7H93Y5", "2BT9EZNDVB", "A4KU9XKTEZ",
  "3ETXMVMNFQ", "56SJNC7WRA", "DVQ6TPX4B8", "BY8QYMK24M",
  "U22EURGYZ", "FKBYZ7S8VK", "ZJQCHSRJW", "MK75M4TFSZ", "C2T4U2XEBK",
  "5WXTB7PQW2", "5J8KB8W4F2", "UEKG2B4V6E", "YRWCV7N74", "GV9YWWCB7",
  "CDAZCZ2FSQ", "WREUQWRSK", "6E3TGPA8RX", "GNZRK4BG6J", "ENTUPWCBJ",
  "8WG2RKTSZ", "UEC4NGTRD", "MEEZXTU9XJ", "DR4GUAK94", "MZ3YRXNAWH",
  "6Y7HX96HY", "T3DDE8GTHD", "B8P7G7GJ9B",
  "Z6FRHU795R", "85PS4RAGR", "7EMHWK33CJ", "5E4Z4X4YNR",
  "GMGHAXX4F4", "UDCBZFBFV", "TB25NA6PB5", "MHPQJKZJYH", "TQPKZSF3JP",
  "PBZHESDS", "SJ8RQ32HET", "ZPF29T5ZF", "C4664RQGT",
  "7F3B7C9VT", "38R9JU8XBJ", "X9FSDZTXC", "SFVVUVQWH8", "5KWGBR9ENR",
  "HRK4SXJCKD", "ER2CV7WG4", "QHBHVW8HT7", "BXG3E9J42N", "TD3CEFPZW",
  "CCY8ZC3EQN", "PY3KSSE7Q", "9493AF22BA", "TBVNB2NTYU", "ZMM8D7RTZ7",
  "CC2T9J4DA", "9HHJEF54CY", "HXRFR9GBP", "J2QR6SJ6EZ", "46AKKEJ5T6",
  "SBNBA5EU7G", "FQNN85BP7X", "RE45P4TZAC", "QXMSSC36S7", "5KEZCNAU2S",
  "YSY9THRR", "DQSHEZQ9R3", "4RAQ2VW8M3", "7CJ2Z5367", "Z79KVW839E",
  "8RSRXVRE6J", "YPK5V97US", "BHSEJMT4TE", "BSB5XSAGC", "PR58QJE6G7",
  "Y37XEPA2K", "Z9J7D445N", "HV2Z9UCAB", "FJ8S9WUHQH", "V6FKVGF4QN",
  "35VATV6C4R", "J84BSY2KK", "ZGCS6QJ88J", "49D4UGFED", "7Y9J3UX969",
  "2VPBCFBRSN", "X9WTWX8K9", "B95YKJ4JP", "JW8AR2HDC",
  "BW97N6XAVQ", "YGRPBH7VBD", "G9K9PF77V3", "VZZD6PNDP", "V3EYZK2P2Q",
  "67UCFDMTFZ", "5V6FSHXHJ6", "JSVXKQ2XG9", "X7KQQGEEG", "2AG5T57JMB",
  "R7A78ZAEFA", "K4PAETEW66", "RHX6UY5MWH",
  "U8S8XJB2W3", "GHXT782X4B", "ERUYGUGCZC", "HXXVXS5X5H", "VDJDTQZNVJ",
  "PECJNWNPJY", "A3H9FW5N6", "D9QWZFY5KA", "PFAPZN2NP", "HDA5MPZ797",
  "HXHW87BTRB", "EZS2F4RAQ", "RJGDWCN49", "VJG2E26ZZJ", "SZKKEEC5RM",
  "H3BK8FHQW", "SXVDAY7KWK", "X6EM4JMQYC", "CD6AN3MB8B", "9636N7RUP",
  "Y47XF5QKD", "2FM7CSWC4K", "H93MQ7NU5S", "XBVE4F8D4", "7UP8VHQN2E",
  "356BZDYZJ", "5SQ2864TJM", "QD9D9JH6NV", "JG7VTHMEDR", "PZ8KUQ9VQN",
  "YQGX2775A", "KED8M77TBJ", "4RDMU9XERE", "NWC5V2APS8", "4DA9QAZJUE",
  "2NY2F8VA93", "E99QXPCJY", "WEPTEJT3R", "X9BXHU3VMW", "G7CK5BJZP9",
  "7AYR7DYFAJ", "48MNQ6V2B9", "6C2D7QDSM", "29VEP8E3J9", "GYH8GJDYAK",
  "JATPU5ZQK6", "3HB57K7EY", "AGQ6HEVP9K", "YDW3ZUPBA", "WZTEFZA7C9",
  "QHQRUP67J", "KTN9DXS7XK", "EXUC8BUFC", "SSPV7BJ", "3QG3RPNBFN",
  "6TQ8HWQAGD", "8U4WZQU6CT", "PSHWFKDM6Q", "FHJHCVQZSC",
  "HNRDDEGH4W", "AZAJCYTH", "37CNJ3QJB5", "QUTQW7N67", "B3222JARV5",
  "ER2D7NUWNE", "9PPFCBHFQU", "NQ6MV64BZ", "VX4XV7V67E", "RBQHKFGTJT",
  "7XXN9HSD6", "9ZHB8KBGVE", "Z9ZDFEAN5Y", "562UBT4Z9E", "B34TTDAQ3E",
  "NAYFS4CB4J", "8FCUYHZ6U", "RUDAZF4AY9", "QT6ZM66NAA",
  "GJCUWZMAE", "PH9WQ3MD58", "T65Z95GT7S", "QK4QUWGX8M",
  "5SHFT8R3GV", "HXNB5ET62B", "XKPSSEZBQP", "MUURVY3RAY",
  "88S6RVYVRS", "KYHGAR2K6G", "GB4PTH9HE6", "CQMK9Z9QDS", "2V6M2Y4NHB",
  "RAFBKDNHJB", "7YKF6UUDHU", "6K285EUYND", "HAU2WNDGS9", "UUJS3VZZ7S",
  "Z883PM9VV7", "YUX346PQ4G", "F5HSYNUD6R", "YH9ZR478EV", "TG33949VZU",
  "8YGJZD7R7", "WUJBPFY2P9", "ZDNA7UR2VA", "D3BHZDXRX4", "MS7JGMT26A",
  "KPDSQR3BUJ", "YXXZYXJW8", "Y2ZVRQPFVM", "5JNCM84Y5", "JPHVCSEUZW",
  "ZUU43H2CV6", "775KRNDKX", "MQZN7YTCWM", "E4CT6H6SM", "ZGH4K8RUCB",
  "32J68NMSGV", "PQ4QJVS4KF", "88ER7J5KBZ", "WZMBJHVXG"
];

